export default __webpack_public_path__ + "static/media/red-team-assessment.31ebee65.png";